
<!--
~ VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as published by
~ the Free Software Foundation, version 3 of the License.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. Look for COPYING file in the top folder.
~ If not, see http://www.gnu.org/licenses/.
-->

<div class="vp-select-projects-dialog" id="taskSelectProjectsDialog">
  <div class="task__dialog-header">
    <div class="mobile-back-button">
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
    <div class="header_lbl disable-select">
      {{'SELECT_PROJECTS' | translate}}
    </div>
    <div class="desktop-close-button">
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="task__dialog-body task__dialog-body--pad">
    <mat-list role="list">
      <mat-radio-group (change)="selectAll()" class="select-project-radio-group" [(ngModel)]="allSelected">
        <mat-list-item role="listitem">
          <mat-radio-button class="radio-button-style" [value]="true">{{ 'ALL_PROJECTS' | translate }}</mat-radio-button>
        </mat-list-item>
        <mat-list-item role="listitem">
          <mat-radio-button class="radio-button-style" [value]="false">{{ 'CONTENT_SELECTED' | translate }}</mat-radio-button>
        </mat-list-item>
      </mat-radio-group>
    </mat-list>
    @if (!allSelected) {
      <div class="selected-projects">
        <div id="select-projects-list-dialog" class="option-list">
          <mat-form-field class="filter-search-textfield">
            <mat-label>{{ 'FIND_THE_PROJECT' | translate }}</mat-label>
            <input matInput [(ngModel)]="searchText">
          </mat-form-field>
          <mat-list role="list" [class.changed]="changed">
            @for (project of projectList  | vpTaskProjectSearch : searchText; track project; let i = $index) {
              <mat-list-item role="listitem" class="project-list-item"
                [class.selected]="i == selectedIndex">
                <div class="list-label-style">
                  <span>{{project.name}}</span>
                </div>
                <div class="list-action-style">
                  <vnc-checkbox [isRoundCheckBox]="true" (change)="projectSelected($event , project)" [checked]="isProjectSelected(project)"></vnc-checkbox>
                </div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    }
  </div>
  <div class="task__dialog-footer">
    <div class="desktop-footer">
      <button matButton (click)="close()">
        {{ 'CANCEL' | translate }}
      </button>
      <button matButton [disabled]="!changed" (click)="saveProjects()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
    @if (changed) {
      <div class="mobile-footer">
        <div class="title">
          {{ 'SETTINGS_UPDATED_APPLY_CHANGES' | translate }}
        </div>
        <div class="save_footer_btn">
          <button matButton (click)="saveProjects()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
